import React from 'react'
import InlinePreloader from '../InlinePreloader'

const FormButton = ({buttonLabel, buttonAction, processing}) => {
  return (
    <button type='submit' disabled={processing} onClick={()=>{buttonAction()}} className='w-full p-4 border border-transparent hover:border-vcm-purple bg-vcm-purple text-white hover:text-vcm-purple text-sm transition duration-200 hover:bg-vcm-light-purple flex items-center justify-center rounded-[8px]'>{processing ? <InlinePreloader /> : buttonLabel }</button>
  )
}

export default FormButton